import {useActions, useLoggedIn, useSettings} from "../../store";
import {useEffect, useRef, useState} from "react";
import {useAdConfig, useAdUnits, useV2AdImpression, useV2AdView,} from "../../api/ads";
import {useFeedback} from "../../store/feedback";
import styled from 'styled-components/macro';
import {PostVote} from "../vote";
import {useIsVisible} from "../../utils/visibility";
import {useFeedAdUnits} from "../../store/hooks";
import {useLocation} from "react-router-dom";
import useVisitorId from "../../utils/ad_utils";
import {handleAdImp} from "../../utils/route_change";
import {themecolors} from "../../utils/themecolors";
import {ExternalLink} from "lucide-react";

const Disclosure = styled.div``;
const Headline = styled.a``;
const GoPro = styled.div``;
const Image = styled.div``;
const Ad = styled.div``;
const AdBy = styled.div``;
const Text = styled.div``;
const Expand = styled.a``;
const ImageContainer = styled.div``;

const DesktopPost = styled(({adUnits, className, view, impress}) => {

    const [unit, setUnit] = useState(false);
    useEffect(() => {
        if (!unit) {
            setUnit(adUnits?.ads.length > 0 ? adUnits.ads.shift() : false);
        }
    }, [adUnits])

    const loggedIn = useLoggedIn();

    const handlePro = () => {
    };

    const ref = useRef();
    const isVisible = false;
    const [hasViewed, setHasViewed] = useState(false);
    useEffect(async () => {
        if (isVisible && !hasViewed) {
            // register view
            setHasViewed(true);
            // await view(unit?.impression, unit?.source, "card-feed");
        }
    }, [isVisible])

    useEffect(async () => {
        if (unit) {
            // register impression
            // await impress(unit?.impression, unit?.source, "card-feed");
        }
    }, [unit])

    return (
        <div className={className} ref={ref}>
            <Ad>
                <Image>
                    <img src={unit.image} />
                </Image>
                <Text>
                    <Headline>
                        {unit.headline}
                    </Headline>
                    <AdBy>
                        Promoted by {unit.brand}
                    </AdBy>
                </Text>
            </Ad>
        </div>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  padding: 12px 16px;
  border: 1px solid #c6c6c6;
  max-width: 768px;
  margin: 12px auto;
  ${Disclosure} {
    font-weight: 500;
    display: flex;
    margin-bottom: 8px;
  }
  ${Ad} {
    display: flex;
    align-items: center;
  }
  ${Headline} {
    font-size: 16px;
    font-weight: 500;
  }
  ${AdBy} {
    font-size: 13px;
  }
  ${Image}, 
  ${Image} img {
    width: 62px;
    height: 62px;
    min-width: 62px;
    min-height: 62px;
    border-radius: 4px;
  }
  ${Image} {
    margin-right: 12px;
  }
  ${Ad} svg {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  @media only screen and (max-width: 630px) {
    ${Ad} svg {
      display: none;
    }
    ${Ad} {
      justify-content: center;
    }
  }
`;

const InFeed = styled(({adUnits, feedKey, index, className, view, impress}) => {

    const location = useLocation();
    const visitorId = useVisitorId();
    const { referrer: signupReferrer, username } = useSettings();

    const cachedAds = useFeedAdUnits(feedKey);
    const actions = useActions();

    const [unit, setUnit] = useState(false);
    const [hasViewed, setHasViewed] = useState(false);
    const numAds = adUnits?.ads.length;

    useEffect(() => {
        if (!hasViewed) {
            if (cachedAds && index.toString() in cachedAds){
                if (!unit) {
                    const cachedValue = cachedAds[index.toString()];
                    // restore the unit
                    setHasViewed(true);
                    setUnit(cachedValue);
                }
            } else {
                setUnit(adUnits?.ads.length > 0 ? adUnits.ads[0] : false);
            }
        }
    }, [numAds])

    const ref = useRef();
    const isVisible = useIsVisible(ref);
    useEffect(async () => {
        if (unit && !hasViewed) {
            adUnits?.ads.shift();
            setHasViewed(true);
            handleAdImp(visitorId, signupReferrer, username)(location);
            actions.feedAdUnitsChanged(feedKey, index, unit);
            await impress(unit?.impression, unit?.source, "desktop-condensed-feed");
            await view(unit?.impression, unit?.source, "desktop-condensed-feed");
        }
    }, [isVisible, unit])

    return unit ? (
        <a href={unit.url}>
        <div className={`${className} in-feed-ad`} ref={ref}>
            <Ad>
                <PostVote score={1} />
                <ImageContainer>
                    <a href={unit.url}>
                        <Image>
                            <img src={unit.image} />
                        </Image>
                    </a>
                </ImageContainer>
                <Text>
                    <Headline href={unit.url}>
                        {unit.headline}
                    </Headline>
                    <AdBy>
                        <Expand href={unit.url}>
                            <ExternalLink size={16} />
                        </Expand>
                        promoted by {unit.brand}
                    </AdBy>
                </Text>
            </Ad>
        </div>
        </a>
    ) : <div ref={ref} />;
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  padding: 8px 12px 8px 0;
  border-radius: 4px;
  ${Disclosure} {
    font-weight: 500;
    display: flex;
    margin-bottom: 8px;
  }
  ${GoPro} {
    margin-left: auto;
    font-size: 15px;
  }
  ${Ad} {
    display: flex;
    align-items: center;
  }
  ${Headline} {
    font-size: 16px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_1};
  }
  ${AdBy} {
    font-size: 13px;
    color: ${({theme}) => theme.color.name === 'dark' ? theme.placeholder_gray_2 : 'inherit'};
    display: flex;
    align-items: center;
  }
  ${Image}, 
  ${Image} img {
    width: 62px;
    height: 62px;
    min-width: 62px;
    min-height: 62px;
    border-radius: 2px;
  }
  ${Image} {
    margin-right: 12px;
  }
  ${Text} {
    line-height: 22px;
    width: 100%;
  }
  ${Expand} {
    color: ${({theme}) => theme.placeholder_gray_2};
    font-size: 16px;
    margin-right: 6px;
    cursor: pointer;
  }
  @media only screen and (max-width: 780px) {
      border-bottom: ${({theme}) => theme.standard_border};
    ${Ad} {
      align-items: initial;
    }
    ${ImageContainer} {
      order: 2;
    }
    ${Image} {
      margin-left: 8px;
      margin-right: 4px;
    }
  }
`;

const AdUnit = ({postPage, feedKey, index}) => {

    const {feedbackCh} = useFeedback();
    const {pro_tier} = useSettings();

    const adConfig = useAdConfig();

    // list of IDs in feed

    const adUnits = useAdUnits();
    const view = useV2AdView(feedbackCh);
    const impress = useV2AdImpression(feedbackCh);

    const [adCount, setAdCount] = useState(adUnits?.ads.length);
    useEffect(() => {
        if (adUnits?.ads.length > adCount) setAdCount(adUnits?.ads.length);
    }, [adUnits]);

    if (pro_tier > 0) return false;

    const v2 = adConfig ? adConfig.v2.activePlacements : false;
    if (!v2) return false;

    if (!adUnits || !adUnits.ads || adCount === 0) return false;
    // todo: here, check if adUnits is empty and reload if so

    if (postPage) {
        return <PreAd adUnits={adUnits} view={view} impress={impress} config={v2.desktopPost} placement={'desktopPost'} />;
    }
    return <PreAd adUnits={adUnits} view={view} impress={impress} config={v2.desktopFeed} placement={'desktopFeed'} feedKey={feedKey} index={index} />;
};

const PreAd = ({adUnits, view, impress, config, placement, feedKey, index}) => {

    const loggedIn = useLoggedIn();

    const [rand, setRand] = useState(Math.floor(Math.random() * 100));
    const isFirstParty = true;

    if (!config) return false;

    const {rate, showToFirstParty, showToThirdParty, showToGuests, showToUsers} = config;

    if (isFirstParty && !showToFirstParty) return false;
    if (!isFirstParty && !showToThirdParty) return false;

    if (loggedIn && !showToUsers) return false;
    if (!loggedIn && !showToGuests) return false;

    if (rand > rate) return false;

    if (placement === "desktopPost") {
        return <DesktopPost adUnits={adUnits} view={view} impress={impress} />;
    }
    return <InFeed feedKey={feedKey} index={index} adUnits={adUnits} view={view} impress={impress} />;
};

export default AdUnit;